var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "devices-max-width-my-account" },
    [
      _c(
        "div",
        {
          staticClass:
            "\n    header-container\n    gds-flex-container--left\n    devices-gap-2 gds-flex-container--wrap\n    gds-flex-container gds-flex-container--space-between"
        },
        [
          _c("h3", { staticClass: "gds-font-medium gds-space-stack-s" }, [
            _vm._v("My Impact")
          ]),
          _vm._v(" "),
          _vm.vm.customDateRangeLabel
            ? _c("span", { staticClass: "gds-font-book gds-font-size-m" }, [
                _vm._v(_vm._s(_vm.vm.customDateRangeLabel))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.vm.customDateRangeError
            ? _c(
                "span",
                { staticClass: "gds-font-book gds-font-size-m gds-text-red" },
                [_vm._v("Custom date range must not exceed one year.")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("HybridDateSelectControl", {
            attrs: {
              config: _vm.vm.devicesSelectControlConfig,
              "option-selected": _vm.onDateRangeSelected
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.vm.loadState
        ? _c("div", { staticClass: "table-loading" })
        : _vm._e(),
      _vm._v(" "),
      _vm.impactsLoaded
        ? _c("ImpactCardGrid", { attrs: { impacts: _vm.vm.impacts } })
        : _vm._e(),
      _vm._v(" "),
      _vm.vm.loadState === "error"
        ? _c("flow-error", {
            attrs: {
              name: "Impact information",
              state: "unavailable",
              img:
                "/wp-content/themes/gmptwentynineteen/assets/images/usage-not-supported.svg"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }